import { ResourceDto } from '@bom-nextgen-keycloak/models';
import {
  CompanyEvent,
  FeaturePage,
  GroupEvent,
  PermissionCompany,
  ScopeApplication,
} from '@bom-nextgen-keycloak/web/shared/data-access';
import { getValueAttributeKeycloak } from '@bom-nextgen-keycloak/web/shared/util';
import { matchPermission, ResourceType } from '../reducer/permission.reducer';

const getComponentCompany = (resources: ResourceDto[]): ResourceType[] => {
  return resources
    .filter(
      (val) =>
        val.type === 'component' &&
        getValueAttributeKeycloak(val.attributes, 'feature').toLowerCase() ===
          FeaturePage.COMPANY.toLowerCase()
    )
    .map((val) => ({
      ...val,
      scopes: val.scopes?.map((scope) => scope.name) || [],
    }));
};

const getComponentGroup = (resources: ResourceDto[]): ResourceType[] => {
  return resources
    .filter(
      (val) =>
        val.type === 'component' &&
        getValueAttributeKeycloak(val.attributes, 'feature').toLowerCase() ===
          FeaturePage.GROUP.toLowerCase()
    )
    .map((val) => ({
      ...val,
      scopes: val.scopes?.map((scope) => scope.name) || [],
    }));
};

export const mapCompanyPermission = (
  resources: ResourceDto[]
): PermissionCompany => {
  const companyComponentList: ResourceType[] = getComponentCompany(resources);
  const groupDetailComponentList: ResourceType[] = resources
    .filter(
      (val) =>
        val.type === 'subset' &&
        getValueAttributeKeycloak(val.attributes, 'feature').toLowerCase() ===
          FeaturePage.GROUP.toLowerCase()
    )
    .map((val) => ({
      ...val,
      scopes: val.scopes?.map((scope) => scope.name) || [],
    }));

  return {
    canViewEdit: matchPermission(
      groupDetailComponentList,
      GroupEvent.DETAIL,
      ScopeApplication.VIEW
    ),
    canViewDelete: matchPermission(
      companyComponentList,
      CompanyEvent.DELETE,
      ScopeApplication.DELETE
    ),
  };
};
